<!--可切换图片控件，样式由外部决定-->
<template>
	<img :src="getResourcesByName(imgNameList[imgIndex])" class="default-img-class">
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
		},
		props: {
			//图片列表，从当前皮肤中的路径
			imgNameList:{
				type:Array,
				required: true
			},
			//图片下标，从imgNameList中拿图片用
			imgIndex:{
				type:Number,
				default:0
			}
		},
		data() {
			return {}
		},
		created() {
		},
		mounted() {},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return resourcesStore.getters.getResourcesByName
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	
.default-img-class{
	
}
</style>